import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";

import { UserRole } from "src/entity/models/FrontendActor";

import useFetch from "src/Components/Common/useFetch";
import { userContext } from "src/Components/Contexts/userContext";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";

const BulkActionDisputedEntries = ({
  selectedRows,
  openBulkActionModal,
  setOpenBulkActionModal,
  allUsers,
  role,
  departmentName,
  setSelectedRows,
  listDrEntries,
  partnerNameRef,
}) => {
  const { actor } = useContext(userContext);
  const [allowUpdatingMaker, setAllowUpdatingMaker] = useState(false);
  const [allowUpdatingChecker, setAllowUpdatingChecker] = useState(false);
  const [allowUpdatingApprover, setAllowUpdatingApprover] = useState(false);

  // const [allowUpdatingComments, setAllowUpdatingComments] = useState(false);
  const [allowUpdatingRemarks, setAllowUpdatingRemarks] = useState(false);
  const [allowUpdatingDueDate, setAllowUpdatingDueDate] = useState(false);
  const [currentDueDate, setCurrentDueDate] = useState(null);
  const [currentMaker, setCurrentMaker] = useState([]);
  const [currentChecker, setCurrentChecker] = useState([]);
  const [currentApprover, setCurrentApprover] = useState([]);
  // const [currentComments, setCurrentComments] = useState(null);
  const [currentRemarks, setCurrentRemarks] = useState(null);

  const handleClose = () => {
    setOpenBulkActionModal(false);
  };

  const updateTakeActionDataAction = async () => {
    await useFetch(API_ENDPOINTS.BULK_UPDATE_DR_ENTRIES_ACTION(role).url, "POST", {
      failureMessage: API_ENDPOINTS.BULK_UPDATE_DR_ENTRIES_ACTION(role).failureMessage,
      showSuccessToast: true,
      data: {
        department: departmentName || "",
        gapId: selectedRows.map((row) => row.gapId),
        makers: currentMaker,
        checkers: currentChecker,
        approvers: currentApprover,
        remark: currentRemarks,
        dueDate: currentDueDate,
      },
      thenCallBack: (_response) => {
        setSelectedRows({});
        listDrEntries(partnerNameRef.current);
        handleClose();
      },
      catchCallBack: () => {},
    });
  };

  return (
    <>
      <Dialog open={openBulkActionModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">Bulk Actions</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <Stack sx={{ gap: 2 }}>
            <Typography variant="subtitle2" sx={{ color: "rgba(0, 0, 0, 0.6)", marginBottom: 1 }}>
              {Object.values(selectedRows)?.filter(Boolean)?.length} Tasks selected
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              <Checkbox checked={allowUpdatingMaker} onChange={(e) => setAllowUpdatingMaker(e.target.checked)} />
              <Autocomplete
                multiple
                size="small"
                value={currentMaker}
                disabled={!allowUpdatingMaker}
                onChange={(_, newValue) => {
                  setCurrentMaker(newValue);
                }}
                sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                disableClearable
                options={allUsers} // Show all users
                renderOption={(props, item) => (
                  <li {...props} key={item.id}>
                    <ListItemText>{item.name}</ListItemText>
                  </li>
                )}
                getOptionLabel={(option: { name: string; id: number }) => option.name}
                renderInput={(params) => <TextField {...params} label="Maker" size="small" />}
              />
            </Box>

            {(actor.userRole === UserRole.DRApprover ||
              actor.userRole === UserRole.DRChecker ||
              actor.userRole === UserRole.ReconDRApprover) && (
              <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                <Checkbox checked={allowUpdatingChecker} onChange={(e) => setAllowUpdatingChecker(e.target.checked)} />
                <Autocomplete
                  multiple
                  size="small"
                  value={currentChecker}
                  disabled={!allowUpdatingChecker}
                  onChange={(_, newValue) => {
                    setCurrentChecker(newValue);
                  }}
                  sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                  disableClearable
                  options={allUsers?.filter(
                    (user) =>
                      user.role === UserRole.DRChecker ||
                      user.role === UserRole.DRApprover ||
                      user.role === UserRole.ReconDRApprover
                  )} // Filter users by role
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      <ListItemText>{item.name}</ListItemText>
                    </li>
                  )}
                  getOptionLabel={(option: { name: string; id: number }) => option.name}
                  renderInput={(params) => <TextField {...params} label="Checker" size="small" />}
                />
              </Box>
            )}
            {(actor.userRole === UserRole.DRApprover || actor.userRole === UserRole.ReconDRApprover) && (
              <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                <Checkbox
                  checked={allowUpdatingApprover}
                  onChange={(e) => setAllowUpdatingApprover(e.target.checked)}
                />
                <Autocomplete
                  multiple
                  size="small"
                  value={currentApprover}
                  disabled={!allowUpdatingApprover}
                  onChange={(_, newValue) => {
                    setCurrentApprover(newValue);
                  }}
                  sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                  disableClearable
                  options={allUsers?.filter(
                    (user) => user.role === UserRole.DRApprover || user.role === UserRole.ReconDRApprover
                  )} // Filter users by role
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      <ListItemText>{item.name}</ListItemText>
                    </li>
                  )}
                  getOptionLabel={(option: { name: string; id: number }) => option.name}
                  renderInput={(params) => <TextField {...params} label="Approver" size="small" />}
                />
              </Box>
            )}
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              <Checkbox checked={allowUpdatingRemarks} onChange={(e) => setAllowUpdatingRemarks(e.target.checked)} />
              <TextField
                // value={currentComments}
                disabled={!allowUpdatingRemarks}
                InputProps={{
                  style: {
                    borderRadius: "4px",
                  },
                }}
                sx={{ width: "100%" }}
                size="small"
                label="Remarks"
                onChange={(e) => {
                  const remarks = e.target?.value.trim();
                  setCurrentRemarks(remarks.length > 0 ? remarks : null);
                }}
                multiline
                maxRows={4}
              />
            </Box>
            {/* <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              <Checkbox checked={allowUpdatingComments} onChange={(e) => setAllowUpdatingComments(e.target.checked)} />
              <TextField
                // value={currentComments}
                disabled={!allowUpdatingComments}
                InputProps={{
                  style: {
                    borderRadius: "4px",
                  },
                }}
                sx={{ width: "100%" }}
                size="small"
                label="Add a comment..."
                onChange={(e) => {
                  const remarks = e.target?.value.trim();
                  setCurrentComments(remarks.length > 0 ? remarks : null);
                }}
                multiline
                maxRows={4}
              />
            </Box> */}

            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              <Checkbox checked={allowUpdatingDueDate} onChange={(e) => setAllowUpdatingDueDate(e.target.checked)} />
              <TextField
                type="date"
                disabled={!allowUpdatingDueDate}
                InputProps={{
                  style: {
                    borderRadius: "4px",
                  },
                }}
                sx={{ width: "100%" }}
                size="small"
                label="Due Date"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setCurrentDueDate(e.target.value);
                }}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <CustomButton size="medium" colorToken="violet" variant="outlined" onClick={handleClose}>
            Cancel
          </CustomButton>
          <CustomButton
            size="medium"
            colorToken="violet"
            variant="contained"
            //   disabled={uploadedFiles?.length === 0 || isLoadingSubmit}
            //   startIcon={<LoadingIcon loading={isLoadingSubmit} />}
            onClick={updateTakeActionDataAction}
          >
            Update
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BulkActionDisputedEntries;
